<template>
  <v-card
    shaped
    color="#CFD8DC"
  >
    <br>
    <br>
    <br>
    <v-card-title>
      <v-row>
        <v-col
          cols="12"
          lg="4"
        >
          <v-text-field
            v-model="search"
            label="Search"
            append-icon="mdi-magnify"
            outlined
            dense
          />
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="newsLetterSubscriptions"
      :search="search"
      disable-sort
      class="elevation-1"
    >
      <template #item="{ item }">
        <tr>
          <td>{{ item.email_id }}</td>
          <td>{{ item.created_at | convertToLocal }}</td>
          <td>
            <p>
              <font
                :color="getColor(item.status)"
                class="font-my-style"
              >
                {{ item.status | statusUpdate }}
              </font>
            </p>
          </td>
          <td>
            <v-btn
              class="mt-n2"
              elevation="1"
              fab
              x-small
              icon
              color="#37474F"
              @click.stop
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </td>
          <td>
            <v-btn
              class="mt-n2"
              elevation="1"
              fab
              x-small
              icon
              color="#C62828"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </v-card>
</template>
<script>
  import moment from 'moment';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'NewsLetterSubscriptions',
    components: {
      'centre-spinner': spinner,
    },
    filters: {
      convertToLocal (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
      statusUpdate (status) {
        if (status === 'open') {
          return 'Open*';
        } else if (status === 'inProgress') {
          return 'Working';
        } else if (status === 'parked') {
          return 'Parked';
        } else {
          return status;
        }
      },
    },
    data () {
      return {
        search: '',
        headers: [
          { text: 'Email', align: 'start', value: 'email_id' },
          { text: 'Subscribed On', value: 'created_at' },
          { text: 'Status', value: 'status' },
          { text: 'Edit', value: 'edit' },
          { text: 'Delete', value: 'delete' },
        ],
        loading: false,
        currentActiveTab: '',
      };
    },
    computed: {
      newsLetterSubscriptions () {
        return this.$store.getters['digitalmarketing/getNewsLetterSubscriptions'];
      },
    },
    methods: {
      async fetchAppModuleNewsLetters (val) {
        this.loading = true;
        this.currentActiveTab = val;
        await this.$store.dispatch('digitalmarketing/fetchNewsLetterSubscriptions', {
          appModuleName: this.currentActiveTab,
        });
        this.loading = false;
      },
      getColor (status) {
        if (status === 'open') {
          return '#2E7D32';
        } else if (status === 'inProgress') {
          return '#E65100';
        } else if (status === 'parked') {
          return '#C62828';
        } else {
          return '#263238';
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
.font-my-style {
  font-weight: bold;
}
</style>
